import './styles.css'
import { mountApp } from './ui/app'

const mount = document.getElementById('app')
if (!mount) {
  throw new Error('#app mount point missing')
}

mountApp(mount)
